import {ActiveRecord} from '../ActiveRecord';
import {StreamEventStatusType} from './CustomStreamEvent';

export class StreamVideo extends ActiveRecord {
  id: string;
  protected _status: StreamEventStatusType;
  startDate: Date;
  endDate: Date;
  duration: Date;

  get status(): StreamEventStatusType {
    return this._status;
  }

  static listAction(query = {}, perPage = 50, page = 0) {
    return new Promise(res => {
      setTimeout(() => res(streamVideos), 300);
    })
  }
}

const streamVideos = [
  new StreamVideo({
    id: '001',
    _status: StreamEventStatusType.finished,
    startDate: new Date(),
    endDate: new Date(),
    duration: new Date((12*60+32)*1000)
  }),
  new StreamVideo({
    id: '002',
    _status: StreamEventStatusType.finished,
    startDate: new Date(),
    duration: new Date((26*60+38)*1000)
  })
];



// WEBPACK FOOTER //
// ./src/api/stream/StreamVideo.ts